var render, staticRenderFns
import script from "./RectangleAreaDrawableMixin.vue?vue&type=script&lang=ts&"
export * from "./RectangleAreaDrawableMixin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports